module.exports = __webpack_public_path__ + "img/isla_de_pascua.baa71c5a.jpg";